import { gql } from '__generated__'

export const GetNotifications = gql(/* GraphQL */ `
    query GetNotifications($page: Int!, $limit: Int!) {
        notifications(page: $page, limit: $limit) {
            pageInfo {
                pageTotal
                pageNumber
                itemTotal
            }
            data {
                notificationData {
                    subject
                    content
                    linkHref
                    linkText
                }
                userId
                id
                notificationType
                isRead
                updatedAt
            }
        }
    }
`)

export const MarkNotificationsAsRead = gql(/* GraphQL */ `
    mutation MarkNotificationsAsRead($ids: [ID!]!) {
        markNotificationsAsRead(ids: $ids) {
            success
            message
        }
    }
`)

export const GetNotificationPreferences = gql(/* GraphQL */ `
    query GetNotificationPreferences {
        notificationPreferences {
            emailOptIn
            smsOptIn
        }
    }
`)

export const UpdateNotificationPreferences = gql(/* GraphQL */ `
    mutation UpdateNotificationPreferences($emailOptIn: Boolean) {
        updateNotificationPreferences(emailOptIn: $emailOptIn) {
            success
        }
    }
`)
